import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { store } from 'store/store'
import { getErrorDescription, getErrorTitle } from 'type/ErrorType'

export const ErrorPage = observer(() => {
  const { error } = store

  return <Page full center>
    <Icon name="error" size={48} error />
    <Gap height={16} />
    <Typo size={14} center error>
      {getErrorTitle(error)}
    </Typo>
    <Gap height={8} />
    <Typo size={12} center pre error>
      {getErrorDescription(error)}
    </Typo>
  </Page>
})
